export enum EASY_REFILL_MEMBERSHIP_PLAN_TYPES {
    CARE = 'CARE',
    CARE_PLUS = 'CARE +',
    ON_DEMAND = 'ON DEMAND VISIT',
    NONE = ''
}
